<template>
  <CreateBtn v-bind="$attrs" :btn-text="displayWord" @create-work="handleClick" />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { Template } from '~/api/interface';
import CreateBtn from '~/design/components/buttons/create-btn.vue';
import { gotoEmptyEditor } from '~/features/createWork';
import { useTemplate } from '~/features/template/components/info';

const props = defineProps<{ template?: Template }>();
const userInfo = useUserInfo();
const { t: $t } = useI18n();

const displayWord = computed(() => {
  if (!userInfo.value) {
    return $t('get-started-for-free');
  }
  if (props.template) {
    return $t('chuang-zuo-tong-kuan');
  }
  return $t('create-with-ai-studio');
});

const handleClick = () => {
  if (!userInfo.value) {
    loginTask.add({
      type: IAfterLoginActionType.CREATE_WORK,
      payload: {},
    });
    navigateTo(`/login?redirect=${encodeURIComponent(encodeURIComponent(location.href))}`);
  } else if (props.template) {
    useTemplate(props.template);
  } else {
    gotoEmptyEditor();
  }
};
</script>
